import { render, staticRenderFns } from "./list-partai.vue?vue&type=template&id=625d6441&"
import script from "./list-partai.vue?vue&type=script&lang=js&"
export * from "./list-partai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-partai.vue"
export default component.exports